import ApplicationAdapter from "./application";

export default class EmailAliasAdapter extends ApplicationAdapter {
  urlForCreateRecord(_, snapshot) {
    let project = snapshot.belongsTo("domain").belongsTo("project");
    return `${this.apiBaseUri}/email/createalias?projectkey=${project.id}`;
  }

  urlForUpdateRecord() {
    return `${this.apiBaseUri}/email/editalias`;
  }

  urlForDeleteRecord(id, _, snapshot) {
    let project = snapshot.belongsTo("domain").belongsTo("project");
    return `${this.apiBaseUri}/email/delete?email=${id}&projectkey=${project.id}`;
  }
}
